import * as React from 'react';
import { FixMeLater } from '../../../utils';
import { Typography, TypographyBaseProps } from '../Typography';
import { useComponentDefaultProps, TypographyHeroSize, DEFAULT_HERO_TAG_MAP } from '../../../theming';

export interface HeroProps extends TypographyBaseProps {
    size?: TypographyHeroSize;
}

const defaultProps: Partial<HeroProps> = {
    size: 'm',
};

export const Hero: React.ForwardRefExoticComponent<HeroProps & React.RefAttributes<HTMLElement>> = React.forwardRef(
    function Hero(props: HeroProps, ref: React.ForwardedRef<FixMeLater>): React.JSX.Element {
        const {
            component: componentProp,
            size = 'm',
            ...other
        } = useComponentDefaultProps('Hero', defaultProps, props);

        return (
            <Typography
                ref={ref}
                family="hero"
                size={size}
                component={componentProp || DEFAULT_HERO_TAG_MAP[typeof size === 'object' ? 'm' : size]}
                {...other}
            />
        );
    }
);
